/**
 * Demo page that intentionally throws a runtime error so Sentry captures it.
 * Access at: /demo/sentry-crash
 *
 * Used to demonstrate Zibby's sentry-triage auto-fix agent end-to-end:
 *   1. Click the button → summarizeAccount() crashes → @sentry/react reports
 *      a real Sentry issue (org `zibby`, project `zibby-frontend`).
 *   2. Trigger the sentry-triage agent at that issue. It clones this repo, uses
 *      codebase-memory to trace summarizeAccount() ← loadDemoAccount(), makes
 *      the smallest correct fix, runs tests, and opens a PR.
 *
 * UNLINKED from navigation — zero blast radius for real users.
 */

import React, { useState } from 'react';
import { loadDemoAccount, summarizeAccount } from './sentryCrashAccount';

export default function SentryCrashDemo() {
  const [banner, setBanner] = useState(null);

  const renderBanner = () => {
    // No try/catch on purpose — the error must propagate so Sentry's global
    // handler captures it (exactly how a real unhandled error is reported).
    const account = loadDemoAccount();
    setBanner(summarizeAccount(account));
  };

  return (
    <div style={{ padding: 48, fontFamily: 'system-ui', maxWidth: 640 }}>
      <h1>Teamy — Sentry auto-fix demo</h1>
      <p style={{ color: '#555', lineHeight: 1.5 }}>
        Clicking the button calls <code>summarizeAccount()</code>, which crashes
        on a fresh session because the account&apos;s <code>preferences</code> block
        hasn&apos;t been hydrated yet. The error is reported to Sentry.
      </p>
      <button
        onClick={renderBanner}
        style={{
          padding: '10px 20px',
          fontSize: 16,
          borderRadius: 8,
          border: '1px solid #d0d0d0',
          background: '#111',
          color: '#fff',
          cursor: 'pointer',
        }}
      >
        Render account banner
      </button>
      {banner && <p style={{ marginTop: 24, fontSize: 18 }}>{banner}</p>}
    </div>
  );
}
